
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSensorWaterVocGoogle as ObiSensorWaterVocGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sensor-water-voc-google.js';
 
 
 

 
 export const ObiSensorWaterVocGoogle = createComponent({
   react: React,
   tagName: 'obi-sensor-water-voc-google',
   elementClass: ObiSensorWaterVocGoogleElement,
   events: {
     
   }
  });
 
 